export const partnerDirectorySelector = state =>
  state.opportunityLink.partnerDirectoryList;

export const partnerDirectoryDetailsSelector = state =>
  state.opportunityLink.partnerDirectoryDetails;
